const ROOT = 'RATE_CARDS_';

const actions = {
  // The engines and their versions, on the root slice because two pages read the same payload: the
  // wizard's Details step and the detail page naming a card's engine. The list rows carry their own.
  LOAD_FORM_DATA_REQUEST: `${ROOT}LOAD_FORM_DATA_REQUEST`,
  LOAD_FORM_DATA_SUCCESS: `${ROOT}LOAD_FORM_DATA_SUCCESS`,
  LOAD_FORM_DATA_ERROR: `${ROOT}LOAD_FORM_DATA_ERROR`,

  LOAD_DATA_REQUEST: `${ROOT}LOAD_DATA_REQUEST`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}LOAD_DATA_ERROR`,

  // Draft cards only, which the row's advertised actions already decide. Owned by the list rather
  // than the card page's slice: what follows a delete here is a refetch, not a navigation.
  DELETE_REQUEST: `${ROOT}DELETE_REQUEST`,
  DELETE_SUCCESS: `${ROOT}DELETE_SUCCESS`,
  DELETE_ERROR: `${ROOT}DELETE_ERROR`,

  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
